import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest, postRequest } from "../../services";
import {
  decryptMessage,
  encryptMessage,
  //   encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";

export const getItemConsumptionDetailsData = createAsyncThunk(
  "PROJECT/getConsumptionDetailsData",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getItemConsumptionReportData = createAsyncThunk(
  "PROJECT/getConsumptionReportData",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getSingleMachinePileData = createAsyncThunk(
  "REPORT/getSingleMachinePileData",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getMultipleMachinePileData = createAsyncThunk(
  "REPORT/getMultipleMachinePileData",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getMachineServiceFeedData = createAsyncThunk(
  "REPORT/getMachineServiceFeedData",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getMachineDeploymentData = createAsyncThunk(
  "REPORT/getMachineDeploymentData",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getMachinePartReportData = createAsyncThunk(
  "REPORT/getMachinePartReportData",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getDieselOverview = createAsyncThunk(
  "REPORT/getDieselOverview",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getSingleEngEffcy = createAsyncThunk(
  "REPORT/ single Engineer Efficiency",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getMultipleEngEffcy = createAsyncThunk(
  "REPORT/ multiple Engineer Efficiency",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getEngProdMonthly = createAsyncThunk(
  "REPORT/ Engineer productivity monthly",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

type SliceState = {
  loading: boolean;
  JwtToken: string;
  loginData: null | "" | Object;
  itemConsumptionDetailsData: null | "" | Object;
  itemConsumptionReportData: null | "" | Object;
  singleMachinePileData: null | "" | Object;
  multipleMachinePileData: null | "" | Object;
  machineServiceFeedData: null | "" | Object;
  machineDeploymentData: null | "" | Object;
  machinePartReportData: null | "" | Object;
  dieselOverview: null | "" | Object;
  singleEngineerEfficiiency: null | "" | Object;
  multipleEngineerEfficiiency: null | "" | Object;
  productivityOfEngineerMonthly: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  JwtToken: "",
  loginData: "",
  itemConsumptionDetailsData: [],
  itemConsumptionReportData: [],
  singleMachinePileData: [],
  multipleMachinePileData: [],
  machineServiceFeedData: [],
  machineDeploymentData: [],
  machinePartReportData: [],
  dieselOverview: [],
  singleEngineerEfficiiency: "",
  multipleEngineerEfficiiency: [],
  productivityOfEngineerMonthly: [],
};

const reportSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setToken(state, action) {
      state.JwtToken = action.payload;
    },
    resetProdOfEngData(state) {
      state.singleEngineerEfficiiency = "";
      state.multipleEngineerEfficiiency = [];
      state.productivityOfEngineerMonthly = [];
    },
    resetConsumptionGraphData(state) {
      state.itemConsumptionReportData = [];
    },
    resetConsumptionTableData(state) {
      state.itemConsumptionDetailsData = [];
    }
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getItemConsumptionDetailsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getItemConsumptionDetailsData.fulfilled,
      (state, action) => {
        state.loading = false;
        const data: any =
          process.env.NODE_ENV === "development"
            ? action.payload?.data
            : decryptMessage(JSON.stringify(action.payload?.data));
        if (data?.status) {
          state.itemConsumptionDetailsData = data?.data;
        } else {
          console.log(data?.status);
          state.itemConsumptionDetailsData = data?.data;
        }
      }
    );
    builder.addCase(getItemConsumptionDetailsData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START
    builder.addCase(getItemConsumptionReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getItemConsumptionReportData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.itemConsumptionReportData = data?.data;
      } else {
        console.log(data?.status);
        state.itemConsumptionReportData = data?.data;
      }
    });
    builder.addCase(getItemConsumptionReportData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Post API CALL START
    builder.addCase(getSingleMachinePileData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleMachinePileData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.singleMachinePileData = data.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getSingleMachinePileData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: Post API CALL START
    builder.addCase(getMultipleMachinePileData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMultipleMachinePileData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.multipleMachinePileData = data.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getMultipleMachinePileData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //START: Get API CALL START
    builder.addCase(getMachineServiceFeedData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMachineServiceFeedData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.machineServiceFeedData = data?.data;
      } else {
        console.log(data?.status);
        state.machineServiceFeedData = data?.data;
      }
    });
    builder.addCase(getMachineServiceFeedData.rejected, (state) => {
      state.loading = true;
    });
    //END: Get API CALL END

    //START: Get API CALL START
    builder.addCase(getMachineDeploymentData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMachineDeploymentData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.machineDeploymentData = data?.data;
      } else {
        console.log(data?.status);
        state.machineDeploymentData = data?.data;
      }
    });
    builder.addCase(getMachineDeploymentData.rejected, (state) => {
      state.loading = true;
    });
    //END: Get API CALL END

    //START: Get API CALL START
    builder.addCase(getMachinePartReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMachinePartReportData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.machinePartReportData = data?.data;
      } else {
        console.log(data?.status);
        state.machinePartReportData = data?.data;
      }
    });
    builder.addCase(getMachinePartReportData.rejected, (state) => {
      state.loading = true;
    });
    //END: Get API CALL END

    //START: Get API CALL START
    builder.addCase(getDieselOverview.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDieselOverview.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.dieselOverview = data?.data;
      } else {
        console.log(data?.status);
        state.dieselOverview = data?.data;
      }
    });
    builder.addCase(getDieselOverview.rejected, (state) => {
      state.loading = true;
    });
    //END: Get API CALL END

    //START: getSingleEngEffcy API CALL START
    builder.addCase(getSingleEngEffcy.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleEngEffcy.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.singleEngineerEfficiiency = data?.data;
      } else {
        console.log(data?.status);
        toaster("error", data?.message);
      }
    });
    builder.addCase(getSingleEngEffcy.rejected, (state) => {
      state.loading = true;
    });
    //END: getSingleEngEffcy API CALL END

    //START: getMultipleEngEffcy API CALL START
    builder.addCase(getMultipleEngEffcy.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMultipleEngEffcy.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.multipleEngineerEfficiiency = data?.data;
      } else {
        toaster("error", data?.message);
      }
    });
    builder.addCase(getMultipleEngEffcy.rejected, (state) => {
      state.loading = true;
    });
    //END: getMultipleEngEffcy API CALL END

    //START: getEngProdMonthly API CALL START
    builder.addCase(getEngProdMonthly.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEngProdMonthly.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.productivityOfEngineerMonthly = data?.data;
      } else {
        toaster("error", data?.message);
      }
    });
    builder.addCase(getEngProdMonthly.rejected, (state) => {
      state.loading = true;
    });
    //END: getEngProdMonthly API CALL END
  },
});

export const reportActions = reportSlice.actions;

export default reportSlice;
